import React from 'react';
import { Link } from 'react-router-dom';
import { PREVIEW_DAYS } from '@shared/ui/home/PreviewView';

const DOORS = [
  {
    to: '/preview',
    title: 'Past tips & results',
    body: 'Top picks, value bets and Prime Picks for every race at every meeting, with how each one finished.',
    cta: 'Browse past tips',
  },
  {
    to: '/preview/picks',
    title: "Past Tippa's Picks",
    body: 'Our strongest runners of each day, every one rated a 55% chance or better, and how they went.',
    cta: "See past Tippa's Picks",
  },
];

/** The landing's invitation into the signed-out preview: look around before signing up. */
const PreviewInvite: React.FC = () => (
  <div className="px-6 py-12 md:px-12 bg-racing-gray">
    <div className="max-w-5xl mx-auto flex flex-col gap-6">
      <div className="flex flex-col gap-3 text-center items-center">
        <p className="text-racing-green text-sm font-semibold uppercase tracking-wider">Free preview · no account needed</p>
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-deep-navy leading-tight">Check out what&apos;s inside before you sign up.</h2>
        <p className="text-gray-500 text-lg max-w-3xl">
          Our preview opens the last {PREVIEW_DAYS} days of TippingIQ exactly as members see it: every meeting, every tip, the results and
          Tippa&apos;s Picks. Have a good look around, then join when you&apos;re ready.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {DOORS.map((d) => (
          <Link
            key={d.to}
            to={d.to}
            className="group flex flex-col gap-2 bg-white rounded-lg border border-gray-200 border-l-4 border-l-racing-green p-6 no-underline hover:shadow-card transition-shadow"
          >
            <h3 className="font-heading font-bold text-deep-navy text-lg m-0">{d.title}</h3>
            <p className="text-gray-500 m-0">{d.body}</p>
            <span className="mt-auto pt-2 text-racing-green font-bold">
              {d.cta} <span aria-hidden="true" className="inline-block transition-transform group-hover:translate-x-1">→</span>
            </span>
          </Link>
        ))}
      </div>
    </div>
  </div>
);

export default PreviewInvite;
